export const GIFTCARD_IMAGE_URL =
  "https://cdn.sanity.io/images/srnt2ltl/production/eb87121f4e1a6bb4ac2fc0be59da2dfb9326dfc4-1598x1106.png?fit=max&w=1200&h=1200"

export const GIFTCARD_IMAGE_REF =
  "image-eb87121f4e1a6bb4ac2fc0be59da2dfb9326dfc4-1598x1106-png"
